module.exports = __webpack_public_path__ + "static/media/geolocator_grey.eb83327d.png";